import {
  blue,
  green,
  lightBlue,
  lightOrange,
  lightTeal,
  lightYellow,
  orange,
  purple,
  red,
  yellow,
} from '@synoptic/ui-kit/palette.js';
import { ThemeMode } from '@synoptic/ui-kit/theme/theme-context.js';

const pickColor = (
  colors: Record<number, string>,
  lowThreshold: number,
  highThreshold: number,
) =>
  Object.entries(colors).flatMap(([k, v]) =>
    Number(k) > lowThreshold && Number(k) < highThreshold ? v : [],
  );

const palette = [
  blue,
  purple,
  green,
  orange,
  red,
  yellow,
  lightBlue,
  lightTeal,
  lightOrange,
  lightYellow,
];

const getCommunityColors = (themeMode: ThemeMode) =>
  palette.flatMap((colors) =>
    themeMode === 'light'
      ? pickColor(colors, 100, 1000)
      : pickColor(colors, 50, 900),
  );

const communityColors = {
  light: getCommunityColors('light'),
  dark: getCommunityColors('dark'),
};

export const getCommunityColor = (themeMode: ThemeMode, community: number) => {
  const colors = communityColors[themeMode];

  return colors[community % colors.length];
};
